import { useMutation } from 'react-query';
import { submitGetHelp } from '../../services/gethelp/gethelp.service';

export default (): any => useMutation<any, void, any, void>((data) => submitGetHelp(data));
